<template>
  <div>
    <div class="target-downloading text-center  mt-5 p-1 font-gray-dark" v-if="downloading">
      <b-spinner small label="Espere ..."></b-spinner>
      <span class="p-1">Espere un momento...</span>
    </div>
    <div v-else>
      <ConversationItem v-for="message in messages" :key="message.id" :message="message" :from="message.from"  :link="message.conversation_url" />
      <ConversationsEmpty v-show="messages.length == 0"/>
    </div>


  </div>
</template>
<script>
  import ConversationItem from './components/ConversationItem'
  import ConversationsEmpty from './ConversationsEmpty'

  export default {
    components: {
      'ConversationItem': ConversationItem,
      'ConversationsEmpty': ConversationsEmpty
    },
    data() {
      return {
        messages: [],
        downloading: true
      }
    },
    methods: {
      conversations() {
        this.api.get('conversation').then(({data}) => {
          this.messages = data
          this.downloading = false
        })
      }
    },
    created() {
      this.conversations()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/#pages/messages/Conversations.vue